import { render, staticRenderFns } from "./manageAdvertising.vue?vue&type=template&id=834b988a&scoped=true"
import script from "./manageAdvertising.vue?vue&type=script&lang=js"
export * from "./manageAdvertising.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "834b988a",
  null
  
)

export default component.exports